// Azure AD B2C parameters

import Constants from 'expo-constants';
const { tenantId,clientId ,tenantName,policy,subscriptionKey,apiUrl,ios,android,web,apiBaseUrlPolicy} = Constants.expoConfig.extra;


const CLIENT_ID = clientId
const CLIENT_SECRET = ''
const TENANT_ID = tenantId
const TENANT_NAME = tenantName
const POLICY = policy
const REDIRECT_URI = {
  ios: ios,
  android:android,
  web: web,
  macos: '',
  windows: ''
}

// What Is an OCP-APIM Subscription Key? An OCP-APIM Subscription Key is an authentication mechanism used to secure access of API services.
// The OCP-APIM Subscription Key is a unique identifier that is used to manage authorization for individual APIs.
const OCP_APIM_SUBSCRIPTION_KEY = subscriptionKey

// API Base URL
const API_BASE_URL = apiUrl
// const API_BASE_URL_POLICY =apiBaseUrlPolicy

// Discovery
const discovery = {
  authorizationEndpoint: `https://${TENANT_NAME}.b2clogin.com/${TENANT_ID}/${POLICY}/oauth2/v2.0/authorize`,
  tokenEndpoint: `https://${TENANT_NAME}.b2clogin.com/${TENANT_ID}/${POLICY}/oauth2/v2.0/token`,
  revocationEndpoint: `https://${TENANT_NAME}.b2clogin.com/${TENANT_ID}/${POLICY}/oauth2/v2.0/logout`
}

export {
  CLIENT_ID,
  CLIENT_SECRET,
  TENANT_ID,
  TENANT_NAME,
  POLICY,
  REDIRECT_URI,
  OCP_APIM_SUBSCRIPTION_KEY,
  API_BASE_URL,
  // API_BASE_URL_POLICY,
  discovery
}
